import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { 
  SuperAdminWidgets, 
  SREWidgets, 
  FinOpsWidgets, 
  AppOwnerWidgets 
} from '../../components/Dashboard/DashboardsWidget';
import VMProvisioningForm from '../../Provisioning/VMProvisioningForm';
import { getDashboardConfig } from '../../Utils/RoleConfig';
import Layout from '../../layout/layout';

const RoleDashboard = () => {
    const storedUser = sessionStorage.getItem('username');

  const user = storedUser ? storedUser : null;
    const role = sessionStorage.getItem('rolename') || sessionStorage.getItem('userRole');

  const dashboardConfig = getDashboardConfig(role);

  const renderWidgets = () => {
    switch (role) {
      case 'super_admin':
        return <SuperAdminWidgets />;
      case 'Admin':
        return <SuperAdminWidgets />;
      case 'SRE':
        return <SREWidgets />;
      case 'finopsupport':
        return <FinOpsWidgets />;
      case 'Client':
        return <AppOwnerWidgets />;
      default:
        return <AppOwnerWidgets />;
    }
  };

  return (
            <Layout pageType="sideBar">
    
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Box sx={{ mb: 4 }}>
        <Typography 
          variant="h4" 
          gutterBottom
          sx={{ 
            fontWeight: 'bold',
            background: `linear-gradient(45deg, ${dashboardConfig.color} 30%, ${dashboardConfig.color}80 90%)`,
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          {dashboardConfig.title}
        </Typography>
        <Typography variant="subtitle1" color="textSecondary">
            Welcome back, {user}! Here's your personalized dashboard overview.
        </Typography>
      </Box>

      {renderWidgets()}

      {/* Provisioning Section for relevant roles */}
      {(user?.role === 'super_admin') && (
        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
            Quick Actions
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <VMProvisioningForm />
            </Grid>
          </Grid>
        </Box>
      )}
    </Box>
    </Layout>
  );
};

export default RoleDashboard;
